export default __webpack_public_path__ + "1b4671d257e0eab1f01a5bd9b66499bf.png";